import styled from "styled-components";
import { deviceSizesMin } from "../../../DeviceSizes";

export const SubMenuBackground = styled.div`
  display: none;

  position: absolute;
  width: 100vw;
  height: calc(100vh - 72px);
  top: 100%;
  background: black;
  opacity: 30%;
  z-index: 998;
`;

export const SubMenuContainer = styled.div`
  position: relative;
  width: 80%;
  margin: auto;
  background: white;
  z-index: 998;
  overflow: hidden;
  height: auto;
  max-height: ${(props) => (props.displaySubMenu ? "100%" : "0")};
  display: ${(props) => (props.displaySubMenu ? "block" : "none")};
  transition: max-height 0.5s;

  @media only screen and ${deviceSizesMin.laptop} {
    position: absolute;
    left: 0;
    top: 100%;

    width: 375px;

    padding: 0 20px 0 20px;

    max-height: none;
    height: auto;
    overflow: visible;

    border: 2px solid black;

    display: ${(props) => (props.displaySubMenu ? "block" : "none")};
  }
`;

export const SubMenuList = styled.ul`
  position: relative;
  list-style: none;
  flex-grow: 1;

  padding: 0;
`;

export const SubMenuHeader = styled.li`
  font-size: 1rem;
  font-weight: 700;
  border-bottom: solid black;
`;

export const SubMenuLinkWrapper = styled.a`
  text-decoration: none;
  color: black;
`;

export const SubMenuListItem = styled.li`
  display: flex;
  padding: 0 18px;
  font-size: 13px;
  font-weight: bolder;
  letter-spacing: 1.25px;
  line-height: 26px;
  align-items: center;

  text-transform: uppercase;

  border: black solid 2px;
  height: 50px;
  margin-top: 10px;

  @media only screen and ${deviceSizesMin.laptop} {
    display: block;

    line-height: 50px;

    padding: 0;
    border: 0;
    text-align: center;

    cursor: pointer;

    &:hover {
      background: black;
      color: white;
    }
  }
`;
